import script from "./DemoNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./DemoNotice.vue?vue&type=script&setup=true&lang=js"

import "./DemoNotice.vue?vue&type=style&index=0&id=a60ffb44&scoped=true&lang=css"

import exportComponent from "/Users/einarbragi/Code/hlada.is/hlada-vue-mapbox/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a60ffb44"]])

export default __exports__